import { useEffect, useState } from 'react';
import cx from 'clsx';

import { campaginDateRange } from '~/domains/campaign/helper';
import { useRouterQueryByKey } from '~/hooks/url';

const { TODAY, YESTERDAY, TOMORROW } = campaginDateRange;
export function HomeCampaignDateTooltips() {
  const campaignDate = useRouterQueryByKey('campaignDate', 'string') || TODAY;
  const [yesterdayVisible, setYesterdayVisible] = useState(true);
  const [tomorrowVisible, setTomorrowVisible] = useState(true);

  useEffect(() => {
    if (!yesterdayVisible || campaignDate !== YESTERDAY) return;

    setTimeout(() => {
      setYesterdayVisible(false);
    }, 3000);
  }, [yesterdayVisible, campaignDate]);

  useEffect(() => {
    if (!tomorrowVisible || campaignDate !== TOMORROW) return;

    if (campaignDate === TOMORROW) {
      setTimeout(() => {
        setTomorrowVisible(false);
      }, 3000);
    }
  }, [tomorrowVisible, campaignDate]);

  return (
    <div className="relative">
      <div
        className={cx(
          yesterdayVisible && campaignDate === YESTERDAY
            ? 'inline-block'
            : 'hidden',
          'absolute -top-[50px] left-0 rounded-[8px] bg-secondary-heavy px-12 py-8 tooltip [&::after]:bottom-[-10px] [&::after]:left-[58px]',
        )}
      >
        <span className="text-gray-000 typo-caption100-regular">
          현재 기준가로 어제 할인가와 상이할 수 있습니다.
        </span>
      </div>
      <div
        className={cx(
          tomorrowVisible && campaignDate === TOMORROW
            ? 'inline-block'
            : 'hidden',
          'absolute -top-[50px] right-0 rounded-[8px] bg-secondary-heavy px-12 py-8 tooltip [&::after]:bottom-[-10px] [&::after]:right-[58px]',
        )}
      >
        <span className="text-gray-000 typo-caption100-regular">
          내일 오픈 가격으로 메시지 할인가와 상이할 수 있습니다.
        </span>
      </div>
    </div>
  );
}
